import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const DropZone = ({ onFileSelect }) => {
  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles?.length > 0) {
      onFileSelect(acceptedFiles[0]);
    }
  }, [onFileSelect]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
    onDrop,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/webp': [],
      'image/tiff': []
    },
    multiple: false
  });

  return (
    <div 
      {...getRootProps()} 
      className={clsx(
        "border-2 border-dashed rounded-xl p-10 text-center cursor-pointer transition-all duration-300",
        isDragActive 
          ? "border-blue-500 bg-blue-50/50 scale-[1.02]" 
          : "border-gray-300 hover:border-blue-400 hover:bg-gray-50 bg-white"
      )}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center gap-4">
        <div className={clsx(
          "p-4 rounded-full",
          isDragActive ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-500"
        )}>
          <SafeIcon icon={FiIcons.FiUploadCloud} className="text-4xl" />
        </div>
        <div>
          <p className="text-lg font-medium text-gray-700">
            {isDragActive ? "Drop image here..." : "Drag & drop an image here"}
          </p>
          <p className="text-sm text-gray-500 mt-1">
            or click to select (JPEG, PNG, WEBP, TIFF)
          </p>
        </div>
      </div>
    </div>
  );
};

export default DropZone;